export const PRIVILEGES = {
    NOTE_MAKEPAYMENT: "NOTE_MAKEPAYMENT",
    ADMIN_PANEL: "ADMIN_PANEL",
    VENDOR: "VENDOR",
    API_CALL: "API_CALL",
    VIEW_NOTES_FOR_SALE: "VIEW_NOTES_FOR_SALE",
    ADD_NOTE_FOR_SALE: "ADD_NOTE_FOR_SALE",
    INVESTOR_PROFILE_CUSTOM: "INVESTOR_PROFILE_CUSTOM",
    INVESTOR_PROFILES_CUSTOM_ADMIN: "INVESTOR_PROFILES_CUSTOM_ADMIN",
    INVESTOR_PROFILE: "INVESTOR_PROFILE",
    SHOW_CONTINGENCY_IN_OFFER: "SHOW_CONTINGENCY_IN_OFFER",
    CANCEL_PURCHASE_CONTRACT: "CANCEL_PURCHASE_CONTRACT",
    SEE_COMPANIES_BY_USER_EMAIL: "SEE_COMPANIES_BY_USER_EMAIL",
    SEE_GROUP_COMPANIES_BY_USER_EMAIL: "SEE_GROUP_COMPANIES_BY_USER_EMAIL",
    CALCULATOR: "CALCULATOR",
    REDEEMING_FACTORS: "REDEEMING_FACTORS",
    MAIN_SCREEN: "MAIN_SCREEN",
    SCREEN_CUSTOMIZATION: "SCREEN_CUSTOMIZATION"
};

export const USER_LOG_ACTION = {
    CALCULATOR_OPEN: "CALCULATOR_OPEN",
    MARKETPLACE_OPEN: "MARKETPLACE_OPEN",
    MANAGE_SEARCHES_OPEN: "MANAGE_SEARCHES_OPEN",
    REPORTS_LIST_FORM_OPEN: "REPORTS_LIST_FORM_OPEN",
    NOTES_CSV_DOWNLOADED: "NOTES_CSV_DOWNLOADED",
    NODS_CSV_DOWNLOADED: "NODS_CSV_DOWNLOADED",
    PROPERTIES_CSV_DOWNLOADED: "PROPERTIES_CSV_DOWNLOADED",
    PAYMENTS_CSV_DOWNLOADED: "PAYMENTS_CSV_DOWNLOADED",
    BUYER_OFFERS_OPEN: "BUYER_OFFERS_OPEN",
    BUYER_OFFERS_RELOADED: "BUYER_OFFERS_RELOADED",
    SELLER_OFFERS_OPEN: "SELLER_OFFERS_OPEN",
    SELLER_OFFERS_RELOADED: "SELLER_OFFERS_RELOADED",
    GROUP_SETTING_OPEN: "GROUP_SETTING_OPEN",
    GROUP_HISTORY_OPEN: "GROUP_HISTORY_OPEN",
    GROUP_MEMBERS_OPEN: "GROUP_MEMBERS_OPEN",
    GROUP_MEMBERS_EXPORT: "GROUP_MEMBERS_EXPORT",
    INVESTOR_PROFILES_CUSTOM_OPEN: "INVESTOR_PROFILES_CUSTOM_OPEN",
    INVESTOR_PROFILE_CUSTOM_VIEWED_BY_GROUP_ADMIN: "INVESTOR_PROFILE_CUSTOM_VIEWED_BY_GROUP_ADMIN",
    ADMIN_GROUP_FIND_MATCHING_NOTES_BY_USER: "ADMIN_GROUP_FIND_MATCHING_NOTES_BY_USER",
    CHATBOT_FAB_OPEN: "CHATBOT_FAB_OPEN",
    CHATBOT_FAB_ITEM_PLATFORM: "CHATBOT_FAB_ITEM_PLATFORM",
    CHATBOT_FAB_ITEM_NOTE_INSIGHT: "CHATBOT_FAB_ITEM_NOTE_INSIGHT",
    CHATBOT_FAB_ITEM_DOMAIN: "CHATBOT_FAB_ITEM_DOMAIN",
    CHATBOT_OPEN: "CHATBOT_OPEN",
    CHATBOT_QUESTION_TYPE_PLATFORM: "CHATBOT_QUESTION_TYPE_PLATFORM",
    CHATBOT_QUESTION_TYPE_NOTE_INSIGHT: "CHATBOT_QUESTION_TYPE_NOTE_INSIGHT",
    CHATBOT_QUESTION_TYPE_DOMAIN: "CHATBOT_QUESTION_TYPE_DOMAIN",
    CHATBOT_MESSAGE_SENT: "CHATBOT_MESSAGE_SENT",
    CHATBOT_NOTES_PICKER_OPEN: "CHATBOT_NOTES_PICKER_OPEN",
    CHATBOT_NOTE_ATTACHED: "CHATBOT_NOTE_ATTACHED",
    CHATBOT_NOTE_DETACHED: "CHATBOT_NOTE_DETACHED",
    CHATBOT_FAQ_QUESTION_USED: "CHATBOT_FAQ_QUESTION_USED",
    CHATBOT_FAQ_LIST_EXPANDED: "CHATBOT_FAQ_LIST_EXPANDED",
    CHATBOT_MESSAGE_RETRY: "CHATBOT_MESSAGE_RETRY",
    CHATBOT_MESSAGE_DISCARDED: "CHATBOT_MESSAGE_DISCARDED",
    CHATBOT_NEW_SESSION: "CHATBOT_NEW_SESSION",
    CHATBOT_SESSION_SELECTED: "CHATBOT_SESSION_SELECTED",
    SERVICER_API_KEYS_FORM_OPEN: "SERVICER_API_KEYS_FORM_OPEN",
};

export const SCREEN_NAMES = {
    MARKETPLACE: "Marketplace"
};

export const MESSAGE_CODES = {
    TUTORIAL: "tutorial"
};

export const CHATBOT_QUESTION_TYPE = {
    PLATFORM: "PLATFORM",
    NOTE_INSIGHT: "NOTE_INSIGHT",
    DOMAIN: "DOMAIN"
};

export const LOGOS = {
    logo: require("@/assets/img/noteunlimited_logo.png"),
    logo_2k: require("@/assets/img/noteunlimited_logo_2k.png"),
    logo_4k: require("@/assets/img/noteunlimited_logo_4k.png"),
    logo_8k: require("@/assets/img/noteunlimited_logo_8k.png"),
    logo_webp: require("@/assets/img/noteunlimited_logo1x.webp"),
    logo_webp_2k: require("@/assets/img/noteunlimited_logo2x.webp"),
    logo_webp_4k: require("@/assets/img/noteunlimited_logo3x.webp"),
    logo_webp_8k: require("@/assets/img/noteunlimited_logo4x.webp"),
};
export const MQ1X = "(max-width: 1919px)";
export const MQ2X = "(max-width: 3839px)";
export const MQ3X = "(max-width: 7679px)";
export const MQ4X = "(min-width: 7680px)";
